import React, { useState } from 'react';
import './Excel.css';
import excelExampleImage from '../../../assets/images/excel-example.png';

function Excel({ setFile, setAddDataSourceOpen, connectDataSource, uploadError, setUploadError }) {
    const [fileName, setFileName] = useState(null);
    const [isDragging, setIsDragging] = useState(false);

    const handleUpload = (e) => {
        const f = e.target.files[0];
        if (f) {
            setFile(f);
            setFileName(f.name);
            // Clear any previous errors when a new file is selected
            if (setUploadError) setUploadError(null);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const f = e.dataTransfer.files[0];
        if (f) {
            setFile(f);
            setFileName(f.name);
            // Clear any previous errors when a new file is selected
            if (setUploadError) setUploadError(null);
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    return (
        <>
            <div className="link-source excel">
                <div className="header">
                    <h2>Upload Excel</h2>
                    <h3>Please upload your excel file below. <br />Size limit is 50MB.</h3>
                </div>
                <div 
                    className={`drag-drop-area ${isDragging ? 'dragging' : ''} ${uploadError ? 'error' : ''}`} 
                    onDrop={handleDrop} 
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                >
                    <p>Drag and drop here or</p>
                    <label htmlFor="fileInput" className="custom-file-upload">
                        Choose File
                    </label>
                    <input 
                        id="fileInput" 
                        className="file-input" 
                        type="file"
                        accept=".xlsx, .xls, .csv" 
                        onChange={handleUpload}
                    />
                    <p className="file-name">{fileName ? fileName : 'No file chosen'}</p>
                </div>
                
                <div className="add-item-actions">
                    <button className="add-item-button cancel" onClick={() => setAddDataSourceOpen(false)}>Later</button>
                    <button 
                        className={`add-item-button create ${!fileName ? 'disabled' : ''}`} 
                        disabled={!fileName} 
                        onClick={() => connectDataSource()}
                    >
                        Upload
                    </button>
                </div>
            </div>
            
            {uploadError && (
                <div className="error-message-container">
                    <div className="error-message">
                        <p><strong>File Validation Error:</strong> {uploadError}</p>
                    </div>
                </div>
            )}
        </>
    );
}

export default Excel; 